export default __webpack_public_path__ + "static/media/bodyPaint-1.cf616501.jpg";